"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _r10CommonComponents = require("r10-common-components");

var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));

var _GridItem = _interopRequireDefault(require("vf-comps/build/components/layouts/grid/GridItem"));

var _reactRouterDom = require("react-router-dom");

var _searchActions = require("../actions/searchActions");

var _reactRedux = require("react-redux");

var _appConstants = require("../constants/appConstants");

var _CustomerCard = _interopRequireDefault(require("./CustomerCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var getAddressesFromCustomer = function getAddressesFromCustomer(customer) {
  var billingAccounts = customer === null || customer === void 0 ? void 0 : customer.billingAccount;
  var contactMediums = billingAccounts === null || billingAccounts === void 0 ? void 0 : billingAccounts.map(function (billingAccount) {
    if (!(billingAccount !== null && billingAccount !== void 0 && billingAccount.contact)) return [{
      characteristic: {
        street1: '',
        street2: '',
        postCode: '',
        city: '',
        stateOrProvince: ''
      }
    }];
    return billingAccount === null || billingAccount === void 0 ? void 0 : billingAccount.contact.map(function (c) {
      var _c$contactMedium;

      return c === null || c === void 0 ? void 0 : (_c$contactMedium = c.contactMedium) === null || _c$contactMedium === void 0 ? void 0 : _c$contactMedium.find(function (contactMedium) {
        return (contactMedium === null || contactMedium === void 0 ? void 0 : contactMedium.mediumType) === 'postal';
      });
    });
  });
  var addresses = contactMediums === null || contactMediums === void 0 ? void 0 : contactMediums.map(function (cMedium) {
    var _cMedium$;

    return (_cMedium$ = cMedium[0]) === null || _cMedium$ === void 0 ? void 0 : _cMedium$.characteristic;
  });
  var stringAddresses = addresses === null || addresses === void 0 ? void 0 : addresses.map(function (address) {
    return "".concat(address !== null && address !== void 0 && address.postCode ? address === null || address === void 0 ? void 0 : address.postCode : '', " ").concat(address === null || address === void 0 ? void 0 : address.street1, " ").concat(address === null || address === void 0 ? void 0 : address.street2, " ").concat(address === null || address === void 0 ? void 0 : address.city, " ").concat(address !== null && address !== void 0 && address.stateOrProvince ? address === null || address === void 0 ? void 0 : address.stateOrProvince : '');
  });
  return stringAddresses;
};

var CardContainer = function CardContainer(_ref) {
  var customersData = _ref.customersData,
      cardConfiguration = _ref.cardConfiguration,
      impersonationToken = _ref.impersonationToken;
  var t = (0, _useTranslation.default)();
  var history = (0, _reactRouterDom.useHistory)();
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state[_appConstants.pkgName];
  }),
      type = _useSelector.type;

  var customer = customersData[0];
  /**
   * navigate to ikki
   */

  (0, _react.useEffect)(function () {
    if (impersonationToken) history.push({
      pathname: cardConfiguration.redirectionURL,
      search: "?jwe=".concat(impersonationToken)
    });
  }, [impersonationToken]); // eslint-disable-line react-hooks/exhaustive-deps

  /**
   *
   * @param {*} customer selected card
   * @returns payload used for dispatch getImpToken
   */

  var getImpersonationPayload = function getImpersonationPayload(customer) {
    var value;
    var typeValue = getVal(customer, '$.party.individualIdentification[0].identificationId');

    if (typeValue.indexOf('-') > 0) {
      var _typeValue$split = typeValue.split('-');

      var _typeValue$split2 = _slicedToArray(_typeValue$split, 2);

      type = _typeValue$split2[0];
      value = _typeValue$split2[1];
    } else {
      value = typeValue;
    }

    return {
      'PROFILE TYPE': 'Consumer',
      'LOGIN TYPE': type,
      'LOGIN VALUE': value,
      GROUP: 'Administrator',
      'CLIENT TYPE': 'Full',
      EMAIL: getVal(customer, "$.party.contactMedium[?(@.mediumType==='Email')].characteristic.emailAddress"),
      MSISDN: '664241394'
    };
  };
  /** mapping path of config to val
   * if string get equivalent translated val
   */


  var getVal = function getVal(customer, pathID) {
    if (pathID === 'undefined' || !pathID) {
      return '';
    }

    if (pathID.includes('$')) {
      return _r10CommonComponents.utils.getValueFromJson(pathID, customer);
    } else {
      return t(pathID);
    }
  };
  /**  handle click on customer details card
   * dispatch get impersonation token action
   * navigate to ikki with impersonation token
   */


  var handleCardClick = function handleCardClick() {
    if (cardConfiguration.ikkiRedirect) {
      dispatch((0, _searchActions.getImpersonationToken)(getImpersonationPayload(customer)));
    } else {
      var _customer$party, _customer$party$indiv, _customer$party$indiv2, _customer$party$indiv3, _customer$party2;

      var addresses = getAddressesFromCustomer(customer);
      var nationalId = customer === null || customer === void 0 ? void 0 : (_customer$party = customer.party) === null || _customer$party === void 0 ? void 0 : (_customer$party$indiv = _customer$party.individualIdentification) === null || _customer$party$indiv === void 0 ? void 0 : (_customer$party$indiv2 = _customer$party$indiv.find(function (el) {
        return el.identificationType === 'Tax';
      })) === null || _customer$party$indiv2 === void 0 ? void 0 : (_customer$party$indiv3 = _customer$party$indiv2.identificationId) === null || _customer$party$indiv3 === void 0 ? void 0 : _customer$party$indiv3.substring(4);
      dispatch({
        type: '@checkout/CHANGE_CHECKOUT_FLOW',
        payload: {
          checkoutFlow: 'existing-customer',
          customerData: {
            name: customer === null || customer === void 0 ? void 0 : (_customer$party2 = customer.party) === null || _customer$party2 === void 0 ? void 0 : _customer$party2.fullName,
            nationalId: nationalId,
            listOfAddress: addresses || [],
            nationality: 'Spanish',
            birthDate: '17-12-1995',
            country: 'Spain'
          }
        }
      });
      history.push(cardConfiguration.redirectionURL);
    }
  };
  /**
   * get all value and send to renderCustomer card with data
   */


  var getCardData = function getCardData() {
    var firstVal = getVal(customer, "".concat(cardConfiguration.firstValue));
    var secondVal = getVal(customer, "".concat(cardConfiguration.secondValue));
    var thirdVal = getVal(customer, "".concat(cardConfiguration.thirdValue));
    var thirdKey = getVal(customer, "".concat(cardConfiguration.thirdKey));
    var fourthVal = getVal(customer, "".concat(cardConfiguration.fourthValue));
    var fourthKey = getVal(customer, "".concat(cardConfiguration.fourthKey));
    return /*#__PURE__*/_react.default.createElement(_GridItem.default, {
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_CustomerCard.default, {
      firstVal: firstVal,
      secondVal: secondVal,
      thirdKey: thirdKey,
      thirdVal: thirdVal,
      fourthKey: fourthKey,
      fourthVal: fourthVal,
      handleCardClick: handleCardClick
    }));
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getCardData());
};

var mapDispatchToProps = {};

var mapStateToProps = function mapStateToProps(state) {
  return {
    impersonationToken: state[_appConstants.pkgName].impersonationToken['access_token']
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CardContainer);

exports.default = _default;